import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {DEVICE_MODEL_NAME, DeviceDetails} from "../Model/Model";
import {
    GetAccessType,
    GetDeviceType,
    GetListStatusZone
} from "../../../../reduxToolkit/EmployeeZones/EmployeeZonesApi";
import {
    CreateDeviceApi,
    GetAntiPassBackType,
    GetAuthentication, GetDeviceDetails,
    GetEscortMode,
    GetListStatusDevice, UpdateDeviceApi
} from "../../../../reduxToolkit/Devices/DevicesApi";
import {GetAllZone} from "../../../../reduxToolkit/EmployeeOnBoarding/EmployeeOnBoardingApi";
import {DeleteItemsApi, GetAllMedia} from "../../../../reduxToolkit/Commons/CommonsApi";
import {getWorkStations} from "../../../../reduxToolkit/CompanyEmployees/CompanyEmployeesApi";
import {toast} from "react-toastify";
import routes from "../../../../Routes/routes";
import { deviceTypeKeyNameEnum} from "../../../../hooks/deviceTypeEnum";
import {errorMsg} from "../../../../Apis/functions";
import {TABLES} from "../../../../Apis/Tables";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 * @function CreateUpdateDevicesApp
 * @description Main component for handling device creation and updates
 * @returns {Object} Contains all state and handler functions for the component
 */
export const CreateUpdateDevicesApp =()=>{
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const {id} = useParams();
    const {permission} = useSelector((state) => state.authenticatioauthennSlice);
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { zoneIdProps, zoneNameProps } = location.state || {};
    // use State hook for local state management
    const [deleteDeviceShow, setDeleteDeviceShow] = useState(false);
    const [selectDeviceForDelete, setSelectDeviceForDelete] = useState([]);
    const [deletedFlag, setDeletedFlag] = useState(false);
    const [data, setData] = useState({...DeviceDetails});
    const [modified, setModified] = useState(false)


    //Enum to deteterminate what type of athentication is able for each type of device
    const allowedAuthentications = {
        [DEVICE_MODEL_NAME.MANTRA_MFSTAB_II]: [1, 2],
        [DEVICE_MODEL_NAME.PDA_CARIBE_PL50L]: [1],
        [DEVICE_MODEL_NAME.TELPO_F6]: [1, 2, 3],
        [DEVICE_MODEL_NAME.TELPO_TPS_980]: [1],
        [DEVICE_MODEL_NAME.TELPO_TPS_450]: [1, 2],
        [DEVICE_MODEL_NAME.TELPO_K5]: [1],
        [DEVICE_MODEL_NAME.TELPO_F10]: [1, 3],
        [DEVICE_MODEL_NAME.TELPO_F6_T]: [1, 3],
        [DEVICE_MODEL_NAME.TELPO_K10]: [1, 3],
        [DEVICE_MODEL_NAME.VERIDAS_1FA]: [1, 3],
        [DEVICE_MODEL_NAME.VERIDAS_2FA]: [1, 3],
        [DEVICE_MODEL_NAME.CAMERA_LPR]: [1, 3],
        [DEVICE_MODEL_NAME.ANTENNA_RFID]: [1, 3],
        [DEVICE_MODEL_NAME.ARATEK_BM7550]: [1, 2, 3],
        [DEVICE_MODEL_NAME.ARATEK_BA8300]: [1, 2, 3],
        [DEVICE_MODEL_NAME.ARATEK_BM5510]: [1, 2],
    };
    //Enum to deteterminate what type distance is able for each type of device
    const allowedDistance = {
        [DEVICE_MODEL_NAME.TELPO_F6]: [30, 50, 80, 100, 150],
        [DEVICE_MODEL_NAME.TELPO_F10]: [30, 50, 80, 100, 150],
        [DEVICE_MODEL_NAME.TELPO_F6_T]: [30, 50, 80, 100, 150],
        [DEVICE_MODEL_NAME.TELPO_K10]: [30, 50, 80, 100, 150],
        [DEVICE_MODEL_NAME.ARATEK_BM7550]: [30, 50, 80, 100, 150],
        [DEVICE_MODEL_NAME.ARATEK_BA8300]: [30, 50, 80, 100, 150],
        [DEVICE_MODEL_NAME.ARATEK_BM5510]: [30, 50, 80, 100, 150],
        [DEVICE_MODEL_NAME.ARATEK_BD8500]: [30, 50, 80, 100, 150],
    };
    //Enum to deteterminate what type distance default for each type of device
     const defaultDistanceValue = {
        [DEVICE_MODEL_NAME.MANTRA_MFSTAB_II]: 0,
        [DEVICE_MODEL_NAME.PDA_CARIBE_PL50L]: 0,
        [DEVICE_MODEL_NAME.TELPO_F6]: 150,
        [DEVICE_MODEL_NAME.TELPO_TPS_980]: 0,
        [DEVICE_MODEL_NAME.TELPO_TPS_450]: 0,
        [DEVICE_MODEL_NAME.TELPO_K5]: 0,
        [DEVICE_MODEL_NAME.TELPO_F10]: 150,
        [DEVICE_MODEL_NAME.TELPO_F6_T]: 150,
        [DEVICE_MODEL_NAME.TELPO_K10]: 150,
        [DEVICE_MODEL_NAME.VERIDAS_1FA]: 0,
        [DEVICE_MODEL_NAME.VERIDAS_2FA]: 0,
        [DEVICE_MODEL_NAME.CAMERA_LPR]: 0,
        [DEVICE_MODEL_NAME.ANTENNA_RFID]: 0,
        [DEVICE_MODEL_NAME.ARATEK_BM7550]: 150,
        [DEVICE_MODEL_NAME.ARATEK_BA8300]: 150,
        [DEVICE_MODEL_NAME.ARATEK_BM5510]: 150,
        [DEVICE_MODEL_NAME.ARATEK_BD8500]: 150,
    };

    const defaultValueReadAfter = [DEVICE_MODEL_NAME.ARATEK_BD8500];
    
    const [deviceTypeAuthentications, setDeviceTypeAuthentications] = useState([allowedAuthentications[data.deviceType]]);
    const [deviceTypeDistance, setDeviceTypeDistance] = useState([allowedDistance[data.deviceType] || [DEVICE_MODEL_NAME.MANTRA_MFSTAB_II]]);
    const [defaultDistance, setDefaultDistance] =useState([defaultDistanceValue[data.deviceType]])
    const [emptyFields, setEmptyFields] = useState(false);
    const [formSubmitted, setFormSubmitted] = useState(false);

    useEffect(()=>{
        setDeviceTypeAuthentications(allowedAuthentications[data.deviceType])
        setDeviceTypeDistance(allowedDistance[data.deviceType] || []);
        setDefaultDistance(defaultDistanceValue[data.deviceType] || []);

        if(id === undefined){
            setEmptyFields(false)
            handleClear(data.deviceType);
        }
    },[data.deviceType])

    useEffect(() => {
        if (data.antiPassBackType === 1) {
            setData(prevData => ({
                ...prevData,
                antiPassBackTime: 0,
                antiPassBackAlert: 1,
            }));
        }
        }, [data.deviceType,data.antiPassBackType,data.requestSignatureAlways]);
   

        useEffect(() => {
            if (defaultValueReadAfter.includes(data.deviceType)) {
                setData((prevData) => ({
                    ...prevData,
                    readAfter: 1,
                }));
            }
        }, [data.deviceType]);

    // This section re-route us when a device is deleted
    useEffect(() => {
        if (deletedFlag) {
            zoneNameProps !== undefined
                ? navigate(routes.zone.details + zoneIdProps)
                : navigate(routes.devices.list);
        }
    }, [deletedFlag]);

    useEffect(() => {
        getData()
        getCatalogs()
    }, []);

    useEffect(() => {
        if (modified) {
            getData()
        }
        setModified(false)
    }, [modified])

    /**
     * @function validateDeviceData
     * @description Validates required device fields
     * @param {Object} body - Device data object
     * @returns {string|null} Error message or null if valid
     */
    const validateDeviceData = (body) => {
        if (!body.deviceTypeId)return true;
        if (!body.deviceAccessTypeId) return true;
        if (!body.serialNumber) return true;
        if (!body.ip) return true;
        if (!body.mac) return true;
        if (!body.readAfter) return true;
        if (!body.statusId)return true;
        if (!body.timeZoneId || !body.timeZoneValue) return true;
        if ( body.enableDistance === true && !body.distance) return true;
        if (!body.escortId) return true;
        if (!body.deviceTypeId === 3){
            if (!body.enableRelay0) return true;
            if (!body.enableRelay1) return true;
        }
        if (
            [
                DEVICE_MODEL_NAME.MANTRA_MFSTAB_II,
                DEVICE_MODEL_NAME.TELPO_F6,
                DEVICE_MODEL_NAME.TELPO_F10,
                DEVICE_MODEL_NAME.TELPO_F6_T,
                DEVICE_MODEL_NAME.ARATEK_BA8300,
            ].includes(body.deviceTypeId)
        ) {
            if (!body.timeForRelay0) return true;
        }
        if (!body.antiPassBackId)return true;
        return false;
    };

    /**
    * @function handleApiResponse
    * @description Handles API response, shows toast messages, and manages navigation logic based on context.
    *
    * @param {Object} response - API response object.
    * @param {boolean} isUpdate - Indicates whether the operation is an update (true) or a creation (false).
    */
    const handleApiResponse = (response, isUpdate = false) => {
        const { success, code } = response.payload.data;

        if (success) {
            // Show success toast message based on the action performed
            const successMessage = isUpdate
                ? 'device_updated_successfully'
                : 'device_created_successfully';
            toast.success(t(successMessage));

            if (zoneNameProps !== undefined) {
                navigate(routes.zone.details + zoneIdProps);
            }
            // If from Devices module:
            else {
                if (isUpdate) {
                    // Just refresh the data
                    setModified(true);
                } else {
                    // If new device, go back to device list
                    navigate(routes.devices.list);
                }
            }
        } else {
            errorMsg(code);
        }
    };

    /**
     * @function handleError
     * @description Handles API errors and displays appropriate toast messages
     * @param {Error} error - Error object from API call
     */
    const handleError = (error) => {
        if (error.response) {
            const statusCode = error.response.status;
            if (statusCode === 500) {
                toast.error(t('server_error').toUpperCase());
            } else {
                toast.error(t('unexpected_error').toUpperCase());
            }
        } else if (error.request) {
            toast.error(t('network_error').toUpperCase());
        } else {
            toast.error(t('unexpected_error').toUpperCase());
        }
    };
    /**
     * @function handelCreateDeviceVeridas
     * @description Handles creation/update of Veridas-specific devices
     */
    const handelCreateDeviceVeridas = async () => {
        const body = {
            antiPassBackAlertById: 1,
            antiPassBackId: 1,
            antiPassBackTime: 1,
            authenticationId: 1,
            deviceAccessTypeId: data.accessType,
            deviceRestrictionId: data.deviceRestriction,
            deviceTypeId: data.deviceType,
            escortId: 1,
            ip: data.ip,
            description: data.description,
            serialNumber: 1,
            liveness: true,
            enableRelay1: true,
            mac: data.mac,
            password: data.password,
            name: data.deviceName,
            deviceId: data.idDevice,
            bluetoothReader: true,
            pin: true,
            readAfter: 1,
            enableRelay0: true,
            requestSignature: 1,
            rfidReader: true,
            showAccessDialog: false,
            showLastAccesses: false,
            showLed: true,
            printer: true,
            showLogo: false,
            showUserList: true,
            showVehicle: false,
            showWeapon: true,
            statusId: data.statusValue,
            syncTime: 1,
            timeZoneId: 1,
            timeZoneValue:(deviceTypeKeyNameEnum.TELPO_K10 === parseInt(data.deviceType) ? data.timeZoneValue: 1),
            consecutiveOpeningsAllowed: 0,
            timeForRelay0: 1,
            timeForRelay1: 1,
            updatedAt: 1,
            facialRecognition: true,
            validationNumber: 1,
            fingerprintReader: true,
            zoneId: data.zoneName === '' ? null : data.zoneName,
            qrCodeReader: true,
            playSound: false,
            requestSignatureAlways: false,
            synchronizeSelfie: false,
            enableTTLock: false,
            enableAirbnk: false,
            enableRelaySR3: false,
            enableRelaySR34ch: false,
            modeId  : data?.modeId,
            enableDistance:false,
            distance:0,

        };

        const validationError = validateDeviceData(body);

        if (validationError) {
            toast.warn(t('please_fill_all_fields'));
            setEmptyFields(true);
            return;
        }

        setFormSubmitted(true);

        try {
            const isUpdate = Boolean(id);
            const apiAction = isUpdate ? UpdateDeviceApi : CreateDeviceApi;
            if (isUpdate) body.id = id;

            const response = await dispatch(apiAction(body));
            handleApiResponse(response, isUpdate);
        } catch (error) {
            handleError(error);
        }
    };
    /**
     * @function handleCreateDevice
     * @description Main function for creating/updating device information
     */
    const handleCreateDevice = async () => {
        const body = {
            name: data.deviceName,
            deviceId: data.idDevice,
            ip: data.ip,
            mac: data.mac,
            serialNumber: data.sn,
            description:
                data.description &&
                typeof data.description === 'string' &&
                data.description.trim() !== ''
                    ? data.description
                    : null,
            authenticationId: data.authentication,
            escortId: data.escortMode,
            deviceAccessTypeId: data.accessType,
            deviceTypeId: data.deviceType,
            statusId: data.statusValue,
            zoneId: data.zoneName === '' ? null : data.zoneName,
            bluetoothReader: data.bluetooth,
            rfidReader: data.smartCard,
            facialRecognition: data.facialRecognition,
            liveness: data.liveness,
            fingerprintReader: data.fingerprint,
            pin: data.pin,
            qrCodeReader: data.qr,
            password:  data.password &&
            typeof data.password === 'string' &&
            data.password.trim() !== ''
                ? data.password
                : null,
            validationNumber: data.validationNumber,
            firebaseId: null,
            readAfter: data.readAfter,
            antiPassBackId: data.antiPassBackType,
            timeZoneId: data.timeZoneValue,
            cameraTypeId: data.cameraTypeId,
            antiPassBackTime: data.antiPassBackTime,
            antiPassBackAlertById: data.antiPassBackAlert,
            syncTime: data.syncTime,
            synchronizeSelfie: data.synchorizeSelfies,
            playSound: data.playSounds,
            requestSignature: data.requestSignature,
            requestSignatureAlways: data.requestSignatureAlways,
            consecutiveOpeningsAllowed: data.consecutiveOpeningsAllowed,
            enableTTLock: data.enableTTLock,
            enableAirbnk: data.enableAirbnk,
            enableRelay: data.enableRelay,
            enableRelay0: data.enableRelay0,
            enableRelay1: data.enableRelay1,
            delayToOpen: data.delayToOpen,
            timeForRelay0: data.timeForRelay0,
            timeForRelay1: data.timeForRelay1,
            enableRelaySR3: data.enableRelaySR3,
            enableRelaySR34ch: data.enableRelaySR34ch,
            deviceRestrictionId: data.deviceRestriction,
            showLogo: data.showLogo,
            showUserList: data.showUserList,
            showWeapon: data.showWeapon,
            showVehicle: data.showVehicle,
            showLed: data.showLed,
            showAccessDialog: data.showAccessDialog,
            showLastAccesses: data.showLastAccess,
            printer: data.printer,
            modeId  : data?.modeId,
            enableDistance:data?.enableDistance,
            openRelayForAll1FA: data?.openRelayForAll1FA,
            openRelayForAll2FA: data?.openRelayForAll2FA,
            enableRelay1FA:data?.enableRelay1FA,
            enableRelay2FA:data?.enableRelay2FA,
            distance: data?.enableDistance === true
            ? data?.distance : defaultDistance[data.deviceType],
            };
        setFormSubmitted(true);

        const sectionsByDeviceType = {
            [DEVICE_MODEL_NAME.MANTRA_MFSTAB_II]: [1, 2, 3, 4],
            [DEVICE_MODEL_NAME.PDA_CARIBE_PL50L]:[1, 2, 3, 4],
            [DEVICE_MODEL_NAME.TELPO_F6]:[1,2, 3, 4, 5, 6],
            [DEVICE_MODEL_NAME.TELPO_TPS_980]: [1, 2, 4],
            [DEVICE_MODEL_NAME.TELPO_TPS_450]:[1, 2, 3, 4],
            [DEVICE_MODEL_NAME.TELPO_K5]:[1, 2, 3, 4, 6],
            [DEVICE_MODEL_NAME.TELPO_F10]:[1, 2, 3, 4, 5, 6],
            [DEVICE_MODEL_NAME.TELPO_F6_T]:[1, 2, 3, 4, 5, 6],
            [DEVICE_MODEL_NAME.TELPO_K10]: [1, 2, 3, 4, 5],
            [DEVICE_MODEL_NAME.VERIDAS_1FA]: [1, 2,],
            [DEVICE_MODEL_NAME.VERIDAS_2FA]: [1, 2],
            [DEVICE_MODEL_NAME.CAMERA_LPR]: [1, 2],
            [DEVICE_MODEL_NAME.ANTENNA_RFID]: [1, 2],
            [DEVICE_MODEL_NAME.ARATEK_BM7550]: [1, 2, 3, 4, 5, 6],
            [DEVICE_MODEL_NAME.ARATEK_BA8300]: [1, 2, 3, 4, 5, 6],
            [DEVICE_MODEL_NAME.ARATEK_BM5510]: [1, 2, 3, 4, 5],
            [DEVICE_MODEL_NAME.ARATEK_BD8500]: [1, 2, 3, 4, 5],
        };

        let sections = sectionsByDeviceType[data.deviceType] || [1, 2, 3, 4, 5,6];

        const hasInvalidSection = sections.some(section => !data.isValid(section));
        if (hasInvalidSection) {
            toast.warn(t('please_fill_all_fields'));
            setEmptyFields(true);
            return;
        }

        setEmptyFields(false)

        try {
            let response;
            if (id) {
                body.id = id;
                response = await dispatch(UpdateDeviceApi(body)).then((response) => {
                    return response;
                })
                    .catch((error) => {
                        return error.response;
                    });
            } else {
                response = await dispatch(CreateDeviceApi(body));
            }

            const {
                data:data,
                success,
                code,
            } = response.payload.data;

            if (success) {
                toast.success(
                    t(
                        id
                            ? 'device_updated_successfully'
                            : 'device_created_successfully'
                    ).toUpperCase()
                );
            } else errorMsg(code)
            if (success) {
                navigate(
                    zoneNameProps !== undefined
                        ? routes.zone.details + zoneIdProps
                        : id
                            ? setModified(true)
                            : routes.devices.list
                );
            }
        } catch (error) {
            handleError(error);
        }
    };
    /**
     * @function deleteSelectedDevices
     * @description Handles device deletion
     * @param {Array} deleteItem - Array of device IDs to delete
     */
    const deleteSelectedDevices = (deleteItem) => {
        const body = deleteItem;

        if (body.length > 0) {
            dispatch(DeleteItemsApi({tableName: TABLES.DEVICES, body})).then(
                ({
                     payload: {
                         data: { success, code },
                     },
                 }) => {
                    if (success === true) {
                        setDeletedFlag(true);
                        setSelectDeviceForDelete([]);
                    } else {
                        errorMsg(code);
                    }
                },
            );
        }
    };

    const handleClear = (deviceType = '') => {
        if(zoneIdProps)
            setData({ ...DeviceDetails, zoneName: zoneIdProps, zone: zoneIdProps, deviceType:deviceType });
        else
            setData({ ...DeviceDetails, deviceType:deviceType });
    };

    const handleDeviceAction = () => {
        const validDeviceTypes = [10, 11, 13, 12];
        validDeviceTypes.includes(data.deviceType) ? handelCreateDeviceVeridas() : handleCreateDevice();
    };

    /**
     * @function handleChange
     * @description Generic input change handler
     * @param {Object|string} evt - Event object or direct value
     * @param {string} [name=""] - Field name to update
     */
    function handleChange(evt, name = "") {
        let value;

        if (evt && evt.target) {
            if (evt.target.type === "checkbox") {
                value = evt.target.checked;
            } else {
                value = evt.target.value;
            }
            if (name === "") {
                name = evt.target.name || "dob";
            }
        } else {
            value = evt;
        }

        setData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    }

    const getCatalogs = () => {
        dispatch(GetListStatusZone());
        dispatch(GetListStatusDevice());
        dispatch(GetAccessType());
        dispatch(GetDeviceType());
        dispatch(GetAntiPassBackType());
        dispatch(GetEscortMode());
        dispatch(GetAuthentication());
        dispatch(GetAllZone());
        dispatch(GetAllMedia());
        dispatch(getWorkStations());
    }

    const getData = () => {

        if (zoneNameProps !== undefined) {
            setData(prev => ({ ...prev, zoneName: zoneIdProps, zone: zoneIdProps }));
        } else if (id !== undefined) {
            dispatch(GetDeviceDetails(id)).then(({ payload: { data: { data } } }) => {
                setData(prev => ({
                    ...prev,
                    deviceName: data?.name,
                    idDevice: data?.deviceId,
                    deviceId: data?.id,
                    zoneName: data?.zoneId,
                    deviceType: data?.deviceTypeId,
                    statusValue: data?.statusId,
                    ip: data?.ip,
                    description: data?.description,
                    password: data?.password,
                    accessType: data?.deviceAccessTypeId,
                    antiPassBackType: data?.antiPassBackId,
                    timeZoneValue: data?.timeZoneId,
                    cameraTypeId: data?.cameraTypeId,
                    antiPassBackTime: data?.antiPassBackTime,
                    antiPassBackAlert: data?.antiPassBackAlertById,
                    escortMode: data?.escortId,
                    authentication: data?.authenticationId,
                    readAfter: data?.readAfter,
                    sn: data?.serialNumber,
                    mac: data?.mac,
                    firebaseId: data?.firebaseId,
                    syncTime: data?.syncTime,
                    validationNumber: data?.validationNumber,
                    smartCard: data?.rfidReader,
                    facialRecognition: data?.facialRecognition,
                    liveness: data?.liveness,
                    qr: data?.qrCodeReader,
                    pin: data?.pin,
                    fingerprint: data?.fingerprintReader,
                    bluetooth: data?.bluetoothReader,
                    showLogo: data?.showLogo,
                    showUserList: data?.showUserList,
                    synchorizeSelfies: data?.synchronizeSelfie,
                    playSounds: data?.playSound,
                    requestSignature: data?.requestSignature,
                    requestSignatureAlways: data?.requestSignatureAlways,
                    enableRelay: data?.enableRelay,
                    enableRelay0: data?.enableRelay0,
                    enableRelay1: data?.enableRelay1,
                    enableRelaySR3: data.enableRelaySR3,
                    enableRelaySR34ch: data.enableRelaySR34ch,
                    deviceRestriction: data?.deviceRestrictionId,
                    delayToOpen: data?.delayToOpen,
                    timeForRelay0: data?.timeForRelay0,
                    consecutiveOpeningsAllowed: data?.consecutiveOpeningsAllowed,
                    timeForRelay1: data?.timeForRelay1,
                    showWeapon: data?.showWeapon,
                    showVehicle: data?.showVehicle,
                    showLed: data?.showLed,
                    showAccessDialog: data?.showAccessDialog,
                    showLastAccess: data?.showLastAccesses,
                    printer: data?.printer,
                    modeId: data?.modeId,
                    enableDistance: data?.enableDistance,
                    distance: data?.distance,
                    openRelayForAll1FA: data?.openRelayForAll1FA,
                    openRelayForAll2FA: data?.openRelayForAll2FA,
                    enableRelay2FA:data?.enableRelay2FA,
                }));
            });
        }
    }


    return {
        data , permission, t, DEV, handleChange, handleClear,
        formSubmitted, deviceTypeAuthentications,emptyFields, id, handleDeviceAction, deleteDeviceShow,
        setDeleteDeviceShow, selectDeviceForDelete, setDeletedFlag, deleteSelectedDevices,
        location, setSelectDeviceForDelete,zoneIdProps, deviceTypeDistance, defaultDistance
    }
}
